import { Alert, AlertTitle, Box, Stack, Tooltip } from '@mui/material';
import PscRisk from '../../constants/psc-risk.constant';
import { useAppSelector } from '../../hooks';

interface PscInspectionRiskProps {
    imoNumber: string;
    index: '0' | '1' | '2';
}

const PscInspectionRisk = ({ imoNumber, index }: PscInspectionRiskProps) => {
    const vesselRisk = useAppSelector((state) => state.MOURisk.Selected[imoNumber]);
    const inspectionRisk = vesselRisk?.InspectionWindow[index];

    const riskStyle = {
        color: 'black',
        border: '2px rgb(0, 42, 78) solid',
        width: 25,
        height: 25,
        borderRadius: '50%'
    };

    const getTootlip = (riskId: string, dateToMediumRisk: string, dateToHighRisk: string) => {
        return (
            <Alert severity="info">
                <AlertTitle>
                    Inspection Risk is <strong>{PscRisk[riskId].text}</strong>
                </AlertTitle>

                {dateToMediumRisk !== dateToHighRisk && (
                    <>
                        {/* Do Not Show 'default' date. */}
                        {dateToMediumRisk !== '0001-Jan-01' && (
                            <>
                                <span>
                                    Date to Medium Risk is <strong>{dateToMediumRisk}</strong>.
                                </span>
                                <br />
                            </>
                        )}

                        {/* Do Not Show 'default' date. */}
                        {dateToHighRisk !== '0001-Jan-01' && (
                            <>
                                <span>
                                    Date to High Risk is <strong>{dateToHighRisk}</strong>.
                                </span>
                                <br />
                            </>
                        )}
                    </>
                )}
            </Alert>
        );
    };

    return (
        <>
            {inspectionRisk ? (
                <Stack direction={'row'} gap={1} justifyContent={'center'}>
                    <Tooltip title={getTootlip(inspectionRisk.RiskId.toString(), vesselRisk.DateToMediumRisk, vesselRisk.DateToHighRisk)} placement="top" arrow>
                        <Box component="span" style={{ ...riskStyle, backgroundColor: PscRisk[inspectionRisk.RiskId.toString()].color }} />
                    </Tooltip>
                </Stack>
            ) : (
                <></>
            )}
        </>
    );
};

export default PscInspectionRisk;
